import { PageSection, PageSectionFace } from 'ui/components/Page'
import { LicensesTable } from '~bank-annual-review/components/LicensesTable'

// eslint-disable-next-line max-len
import { LicensingQuestionnaire } from './components/LicensingQuestionnaire'

export const Licensing = (): JSX.Element => (
  <PageSection title="Licensing" face={PageSectionFace.SECONDARY}>
    <LicensesTable routeApi={'/_app/annual-review/edit/$companyId/$id'} />
    <LicensingQuestionnaire />
  </PageSection>
)
